import React , {useEffect, useState} from 'react';
import { Button, Table } from 'antd';
import {
  faCaretDown,
  faCaretRight
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {useDispatch, useSelector} from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { DatePicker } from 'antd';

import { userActions } from '../../store';
import { ExpandChildrenButton } from './styled';
import { environment, ENVIRONMENTS } from '../../helpers';


const DirectReports = () => {

  const dispatch = useDispatch();
  const { instance } = useMsal();

  const { RangePicker } = DatePicker;

  const userToken = instance.getActiveAccount();

  const replaceSelfWithUserId = localStorage.getItem('superSecretReplaceSelfWithUserIdForDirectReports');

  const directReportsWithTime = useSelector(state => state.user.directReportsWithTime);
  const reduxDirectReports = useSelector(state => state.user.getDirectReports);

  const [directReports, setDirectReports] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const AllowManualIdEntry = () => {
    if (environment === ENVIRONMENTS.DEV) {
      return true;
    } else if (environment === ENVIRONMENTS.TEST) {
      return true;
    } else if (environment === ENVIRONMENTS.STAGING) {
      return true;
    }
      
    return false;
  }

  useEffect(() => {
    //This is here so we continue to see the nav bar option for direct reports if we refresh while already here
    if(reduxDirectReports.data <= 0 && !reduxDirectReports.isError && !reduxDirectReports.isLoading){
      dispatch(userActions.getDirectReports(userToken?.idTokenClaims?.oid));
    }
  }, []);

  useEffect(() => {
    if (directReportsWithTime.data && !directReportsWithTime.isError && !directReportsWithTime.isLoading) {
      setDirectReports(directReportsWithTime.data);
    }
  }, [directReportsWithTime]);

  const defaultColumns = [
    {
      title: 'Display Name',
      dataIndex: 'displayName',
      key: 'displayName',
      width: 300,
    },
    {
      title: 'Admin',
      dataIndex: 'adminTime',
      key: 'adminTime',
    },
    {
      title: 'Lrs',
      dataIndex: 'lrsTime',
      key: 'lrsTime',
    },
    {
      title: 'Engineering',
      dataIndex: 'vpinTime',
      key: 'vpinTime',
    },
    {
      title: 'Gprs',
      dataIndex: 'gprsTime',
      key: 'gprsTime',
    },
    {
      title: 'Total',
      dataIndex: 'totalTime',
      key: 'totalTime',
    },
  ];

  const handleOpenOnClick = (onExpand, record) => {
    if(record.directReports){
      onExpand(record);
      return
    }
    dispatch(userActions.getDirectReportsWithTimes(record.id, startDate, endDate));
    
    onExpand(record);  
  };

  const handleSearchOnClick = () => {
    if(!startDate || !endDate){
      return;
    }

    if(replaceSelfWithUserId && AllowManualIdEntry()){
      dispatch(userActions.getDirectReportsWithTimes(replaceSelfWithUserId, startDate, endDate));
      return;
    }
    else {
      dispatch(userActions.getDirectReportsWithTimes(userToken.localAccountId, startDate, endDate))
      return;
    }
  };

  const handleDateOnChange = (dateString) => {
    dispatch(userActions.resetDirectReportsWithTimes());
    setDirectReports([]);
    setStartDate(dateString[0]);
    setEndDate(dateString[1]);
  };

  return (
    <>
      <span>
        <RangePicker onChange={(_, dateString) => (handleDateOnChange(dateString))} />
        <Button disabled={!startDate || !endDate} loading={directReportsWithTime.isLoading} type="primary" onClick={handleSearchOnClick}>Search</Button>
      </span>
      
      <Table
        className="direct-reports-table"
        showHeader
        columns={defaultColumns}
        expandable={{
          childrenColumnName: 'directReports',
          indentSize: 25,
          expandIcon: ({ expanded, record, onExpand }) => {
            const { id } = record;

            if (record.directReports && record.directReports.length === 0) {
              return null;
            }

            return (
              <ExpandChildrenButton
                type="link"
                disabled={directReportsWithTime.isLoading}
                icon={
                  <FontAwesomeIcon
                    icon={expanded ? faCaretDown : faCaretRight}
                  />
                }
                onClick={() => expanded ? onExpand(record) : handleOpenOnClick(onExpand, record) }
                id={id}
              />
            );
          },
        }}
        tableLayout="fixed"
        rowKey={(user) => user.id + startDate + endDate}
        dataSource={directReports}
        pagination={false}
        style={{ width: '100%' }}
      />
    </>
  );
}

export default DirectReports;